import { useEffect } from 'react';

/** Класс на `<body>`, пока элемент лежит в нижней полосе экрана. */
export const PILL_HIDDEN_CLASS = 'demo-pill-yield';

/**
 * Уводит плавающую пилюлю ассистента, пока элемент `ref` находится в нижней
 * полосе экрана высотой `band` px — там, где пилюля стоит.
 *
 * Пилюля — общая с виджетом у дилеров, её не трогаем: хук только ставит класс
 * на `<body>`, а прятать её по этому классу умеет оболочка демо
 * (`styles/demo-shell.css`, в бандл виджета не попадает). Полосу меряем
 * IntersectionObserver-ом с корнем, ужатым сверху до нижних `band` px:
 * пилюля уходит ровно тогда, когда под ней форма, а не всё время, пока форма
 * где-то на экране.
 *
 * @param {import('react').RefObject<Element>} ref — что пилюля не должна закрывать
 * @param {number} band — высота полосы пилюли снизу экрана, px
 */
export function useHidePillOver(ref, band = 112) {
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    let observer;
    const attach = () => {
      observer?.disconnect();
      const top = Math.max(0, window.innerHeight - band);
      observer = new IntersectionObserver(
        ([entry]) => {
          document.body.classList.toggle(PILL_HIDDEN_CLASS, entry.isIntersecting);
        },
        { rootMargin: `-${top}px 0px 0px 0px` }
      );
      observer.observe(el);
    };
    attach();
    window.addEventListener('resize', attach);
    return () => {
      window.removeEventListener('resize', attach);
      observer?.disconnect();
      document.body.classList.remove(PILL_HIDDEN_CLASS);
    };
  }, [ref, band]);
}
